import React from 'react';
import moment from 'moment-jalaali';
import { RouteComponentProps, Redirect } from '@reach/router';
import { convertDigitToProperFormat } from 'utils/number';
import RelatedResponseItem from 'components/Chart/RelatedResponses/RelatedResponseItem';
import { getEffectiveName } from 'components/FileManager/ItemsViewer/Survey/SurveyEditor/UniqueQuestion/PeriodTypeSelector/DatePeriod';
import { RelatedItemsWrapper } from 'components/Chart/RelatedResponses/styles';
import { ITags } from 'store/providers/providerTypes';
import { IUser } from 'store/users/usersType';
import {
  IAnswersView,
  IGridQuestionView,
  IMultipleChoiceQuestionView,
  ISurveyItem,
  ISurveyResponseView,
  ISurveyViewServer,
  ISurveyViewWithData,
} from 'store/survey/surveyTypes';
import { getCalendarLocal } from '../../i18n';

type IComponentProps = RouteComponentProps;

interface IComponentStates {
  tags?: ITags['data'];
  users?: IUser[];
  surveys?: ISurveyViewServer[];
  responses?: ISurveyResponseView[];
  selectedTags?: number[];
  selectedChoices?: Array<string | number>;
  singlePagePrint?: boolean;
  survey?: ISurveyViewWithData;
  surveyItem?: ISurveyItem;
  providerId?: number;
}

class PrintResponses extends React.PureComponent<
  IComponentProps,
  IComponentStates
> {
  constructor(props: IComponentProps) {
    super(props);
    const dataString = localStorage.getItem('printableResponses');
    if (dataString) {
      localStorage.removeItem('printableResponses');

      const data = JSON.parse(dataString);
      this.state = {
        tags: data.tags,
        users: data.users,
        surveys: data.surveys,
        responses: data.responses,
        selectedTags: data.selectedTags,
        selectedChoices: data.selectedChoices,
        singlePagePrint: data.singlePagePrint,
        survey: data.survey,
        surveyItem: data.surveyItem,
        providerId: data.providerId,
      };
    } else {
      this.state = {};
    }
  }

  componentDidMount() {
    setTimeout(window.print, 2000);
  }

  render() {
    const {
      tags,
      users,
      surveys,
      responses,
      selectedTags,
      selectedChoices,
      singlePagePrint,
      survey,
      surveyItem,
      providerId,
    } = this.state;
    if (
      !surveys ||
      !responses ||
      !tags ||
      !users ||
      !selectedChoices ||
      !selectedTags
    ) {
      return <Redirect to="/notfound" />;
    }
    return (
      <RelatedItemsWrapper>
        <React.Fragment>
          {responses
            .sort((a, b) => {
              if (b.submitDate && a.submitDate) {
                return b.submitDate - a.submitDate;
              }
              return 0;
            })
            .map((response: ISurveyResponseView) => {
              const responseId = response.id;
              const relatedSurvey = surveys.find(
                (s: ISurveyViewServer) => s.id === response.surveyId
              );
              if (!relatedSurvey) {
                return null;
              }
              const periodType = relatedSurvey.periodType;
              const questionList =
                survey && relatedSurvey.id === survey.data.id
                  ? survey.data.versions[survey.viewingVersion!]
                      ?.questionList || relatedSurvey.surveyQuestionList
                  : relatedSurvey.surveyQuestionList;
              const distinctiveQuestions =
                questionList?.filter(
                  (question) =>
                    question.type === 'multipleChoice' &&
                    !question.deleted &&
                    question.distinctive
                ) || [];
              const answersList = response.surveyAnswerList.filter(
                (answer: IAnswersView) => {
                  if (
                    answer.type === 'grid' ||
                    answer.type === 'multipleChoice'
                  ) {
                    return true;
                  }
                  return false;
                }
              );
              return (
                <RelatedResponseItem
                  key={responseId}
                  tags={tags}
                  title={response.title as string}
                  answeredBy={users[response.userId as number].name}
                  survey={survey?.data}
                  surveyItem={surveyItem}
                  providerId={providerId}
                  answersList={answersList}
                  selectedTags={selectedTags}
                  singlePagePrint={singlePagePrint}
                  selectedChoices={selectedChoices}
                  submitDate={convertDigitToProperFormat(
                    moment(response.submitDate).format('jD jMMMM jYYYY')
                  )}
                  distinctiveQuestions={
                    distinctiveQuestions as IMultipleChoiceQuestionView[]
                  }
                  effectiveDate={
                    periodType !== 'none' &&
                    getEffectiveName(
                      periodType,
                      response.effectiveDate as number,
                      getCalendarLocal()
                    )
                  }
                  relatedQuestionsList={
                    questionList as Array<
                      IMultipleChoiceQuestionView | IGridQuestionView
                    >
                  }
                />
              );
            })}
        </React.Fragment>
      </RelatedItemsWrapper>
    );
  }
}

export default PrintResponses;
